<main id="main">
    <section class="academy academy-thank-you-section thankyou">
        <div class="container aos-init aos-animate">
            <div class="row">
                <div class="col-md-12 quiz-main-body">
                    <div class="content">
                        <div class="container-fluid">

                            <div class="col-md-12">
                                <div class="jumbotron text-center">
                                    <div class="Thank-you-gif">
                                        <img src="assets/img/players/output-onlinegiftools.gif" alt="">
                                    </div>
                                    <h1 class="display-6 mb-0 mt-6">Welcome Onboard!</h1>
                                    <p class="lead"><strong>Your Academy Registration has been completed successfully.
                                        </strong>
                                    </p>
                                    <hr>
                                    <p>
                                       Please <a (click)="redirectpage()" style="color: #34c759;  cursor: pointer;">Click here</a> and
                                        complete your Payment. Login Details are sent to your registered email address.
                                    </p>
                                </div>
                            </div>
                        </div> <!-- ENd of container fluid -->

                    </div>
                </div>
            </div>
        </div>
    </section>
</main>